import { render } from "./ActionMenuItem.vue?vue&type=template&id=fbaaab9c"
import script from "./ActionMenuItem.vue?vue&type=script&lang=js"
export * from "./ActionMenuItem.vue?vue&type=script&lang=js"

import "./ActionMenuItem.vue?vue&type=style&index=0&id=fbaaab9c&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__